import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cap-body" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DxScrolling = _resolveComponent("DxScrolling")!
  const _component_DxPopup = _resolveComponent("DxPopup")!
  const _component_DxItem = _resolveComponent("DxItem")!
  const _component_DxFormPopup = _resolveComponent("DxFormPopup")!
  const _component_DxEditing = _resolveComponent("DxEditing")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxLookup = _resolveComponent("DxLookup")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_DxDataGrid, {
      "data-source": _ctx.ds,
      ref: "gridRef",
      "key-expr": "Id",
      "show-borders": true,
      height: "100%",
      "row-alternation-enabled": true,
      "hover-state-enabled": true,
      "no-data-text": "Nu există repartizări pentru angajatul selectat.",
      onContextMenuPreparing: _ctx.onContextMenu
    }, {
      default: _withCtx(() => [
        _createVNode(_component_DxScrolling, { mode: "virtual" }),
        _createVNode(_component_DxEditing, {
          "allow-updating": true,
          "allow-deleting": true,
          "allow-adding": true,
          mode: "popup"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxPopup, {
              "show-title": true,
              title: "Repartizare centru de cost",
              width: 560,
              height: 400
            }),
            _createVNode(_component_DxFormPopup, { "col-count": 1 }, {
              default: _withCtx(() => [
                _createVNode(_component_DxItem, { "data-field": "Data" }),
                _createVNode(_component_DxItem, { "data-field": "CapitolId" }),
                _createVNode(_component_DxItem, { "data-field": "Ore" }),
                _createVNode(_component_DxItem, { "data-field": "Suma" }),
                _createVNode(_component_DxItem, { "data-field": "ContId" })
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Data",
          caption: "Data",
          "data-type": "date",
          format: "dd.MM.yyyy",
          width: 120
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "CapitolId",
          caption: "Centru de cost",
          "min-width": 200
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsCapitole,
              "value-expr": "Id",
              "display-expr": _ctx.capDisplay,
              "search-enabled": true
            }, null, 8, ["data-source", "display-expr"])
          ]),
          _: 1
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Ore",
          caption: "Ore",
          "data-type": "number",
          width: 80,
          alignment: "center"
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "Suma",
          caption: "Sumă",
          "data-type": "number",
          format: "#,##0.00",
          width: 110
        }),
        _createVNode(_component_DxColumn, {
          "data-field": "ContId",
          caption: "Cont contabil",
          "min-width": 180
        }, {
          default: _withCtx(() => [
            _createVNode(_component_DxLookup, {
              "data-source": _ctx.dsConturi,
              "value-expr": "Id",
              "display-expr": _ctx.contDisplay,
              "search-enabled": true
            }, null, 8, ["data-source", "display-expr"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["data-source", "onContextMenuPreparing"])
  ]))
}